import { render, staticRenderFns } from "./EpoRoleNoticeHost.vue?vue&type=template&id=7dd527b8&scoped=true&"
import script from "./EpoRoleNoticeHost.vue?vue&type=script&lang=js&"
export * from "./EpoRoleNoticeHost.vue?vue&type=script&lang=js&"
import style0 from "./EpoRoleNoticeHost.vue?vue&type=style&index=0&id=7dd527b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd527b8",
  null
  
)

export default component.exports